import { ExportOutlined } from '@ant-design/icons';
import { useMutation } from '@apollo/client';
import { Button, Form } from 'antd';
import React, { useState } from 'react';
import {
  EXPORT_TYPES,
  MODULES,
  TRANSFER_ORDER_TYPE,
} from '../../../../../common/constants';
import ExportDateRangeModal from '../../../../../components/ExportDateRangeModal';
import Portal from '../../../../../components/Portal';
import TransferOrderTable from '../components/TransferOrderTable';
import TransferTabs from '../components/TransferTabs';
import { REQUEST_TRANSFER_ORDER_EXPORT_ADMIN } from '../graphql/Mutations';

const TransferOut = () => {
  const [form] = Form.useForm();
  const [exportFilter, setExportFilter] = useState();
  const [isExportLoading, setIsExportLoading] = useState(false);
  const [isModalOpen, setIsModalOpen] = useState(false);

  const [requestTransferOrderExportAdmin] = useMutation(
    REQUEST_TRANSFER_ORDER_EXPORT_ADMIN,
    {
      onError: () => {},
    },
  );

  const handleExport = async (values) => {
    setIsExportLoading(true);
    const res = await requestTransferOrderExportAdmin({
      variables: {
        data: {
          type: EXPORT_TYPES?.TRANSFER_ORDER_OUT,
        },
        filter: {
          search: exportFilter?.search,
          type: TRANSFER_ORDER_TYPE?.OUT?.key,
          dateRange: {
            from: values?.date?.[0]?.startOf('day'),
            to: values?.date?.[1]?.endOf('day'),
          },
          status:
            exportFilter?.status?.length > 0 ? exportFilter?.status : undefined,
        },
      },
    });
    if (res?.data) {
      setIsModalOpen(false);
      form?.resetFields();
    }
    setIsExportLoading(false);
  };

  return (
    <>
      <Portal portalId="header-title-content">
        <div className="portal-header">{MODULES?.TRANSFER}</div>
      </Portal>
      <Portal portalId="header-right-content">
        <Button
          className="common-button ml-16"
          size="middle"
          icon={<ExportOutlined />}
          onClick={() => setIsModalOpen(true)}
          loading={isExportLoading}
        >
          Export
        </Button>
      </Portal>
      <Portal portalId="header-right-content-phones">
        <Button
          className="common-button ml-16"
          size="middle"
          icon={<ExportOutlined />}
          onClick={() => setIsModalOpen(true)}
          loading={isExportLoading}
        >
          Export
        </Button>
      </Portal>
      <ExportDateRangeModal
        form={form}
        onFinish={handleExport}
        loadings={isExportLoading}
        isModalOpen={isModalOpen}
        setIsModalOpen={setIsModalOpen}
      />
      <TransferTabs>
        <div className="tab-table">
          <TransferOrderTable
            exportFilter={exportFilter}
            setExportFilter={setExportFilter}
            orderTransferType={TRANSFER_ORDER_TYPE?.OUT?.key}
          />
        </div>
      </TransferTabs>
    </>
  );
};

export default TransferOut;
